module.exports = __webpack_public_path__ + "static/media/d3-transform.ba860df3.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-transform/build/d3-transform.mjs
// module id = 774
// module chunks = 0